import type { SeaState } from '@sea/world';

/**
 * M0 只有「一个人看世界」，所以状态就是一个可变对象。
 * 等 M1 接入玩家与 Needle 的 Behaviour 体系后，再拆成 InputState / WorldState。
 */
export interface ViewState {
  /** 世界种子：决定波组、岛屿序列 */
  seed: number;
  seaState: SeaState;
  /** 航速 m/s */
  speed: number;
  /** 船体摇摆强度 0..1（0 = 地平线锁死，1 = 完全跟随） */
  motion: number;
  /** 世界时间（秒），所有确定性计算的唯一时间输入 */
  time: number;
  /** 已航行距离（米） */
  distance: number;
}

export const state: ViewState = {
  seed: 1337,
  seaState: 'swell',
  speed: 3,
  motion: 0.4,
  time: 0,
  distance: 0,
};

/** 雾：既是美术，也是「岛屿凭空出现」的遮羞布（§3.2）。太浓会把海整个吃掉。 */
export const FOG = {
  near: 120,
  far: 560,
} as const;
